import config from '@feature-config/finance/options-trading/feature.config.json';
import { createFeatureModule } from '../../createFeatureModule';
import type { FeatureModule } from '../../types';
import { OptionsTradingFeature } from './OptionsTradingFeature';

const optionsTradingFeature: FeatureModule = createFeatureModule(
  config,
  OptionsTradingFeature,
  'finance/options-trading'
);

export default optionsTradingFeature;
